/* Opt-in price rendering. No page scanning or MutationObserver. */
(function () {
    'use strict';
    function escapeText(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, character => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;',
        })[character]);
    }
    function html(value) {
        const match = String(value == null ? '' : value).match(/^([\s\S]*?)\s+ت$/u);
        return match
            ? '<span class="arz-irt-price" dir="rtl"><span>' + escapeText(match[1]) + '</span><span class="arz-irt-symbol" role="img" aria-label="تومان"></span></span>'
            : escapeText(value);
    }
    function render(element, value) {
        if (element.hasAttribute('data-irt-symbol')) element.innerHTML = html(value);
        else element.textContent = value;
    }
    const api = { html, render };
    if (typeof module !== 'undefined' && module.exports) module.exports = api;
    else if (typeof window !== 'undefined') window.ArzIrt = api;
})();
